import { BespokeServicesSection } from "@/components/sections/bespoke-services-section";
import { CtaSection } from "@/components/sections/cta-section";
import { HeroSection } from "@/components/sections/hero-section";
import { ProcessSection } from "@/components/sections/process-section";
import { Seo } from "@/components/seo/seo";
import { useSiteContent, useSiteShared } from "@/config/use-site-content";
import { useLocale } from "@/i18n/locale-context";
import { organizationJsonLd, websiteJsonLd } from "@/lib/structured-data";

export function HomePage(): JSX.Element {
  const { locale } = useLocale();
  const content = useSiteContent();
  const shared = useSiteShared();

  return (
    <>
      <Seo
        description={content.pages.home.description}
        jsonLd={[
          organizationJsonLd(shared, content),
          websiteJsonLd(shared, content),
        ]}
        locale={locale}
        pathWithoutLocale="/"
        title={content.pages.home.title}
      />
      <HeroSection content={content.home.hero} />
      <BespokeServicesSection content={content.home.servicesPreview} />
      <ProcessSection content={content.home.processPreview} />
      <CtaSection content={content.home.cta} />
    </>
  );
}
